<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M2.66667 13V3H13.3333V13H2.66667ZM4 4.5H12V11.5H4V4.5Z" fill="currentColor" />
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 16V0H16V16H0ZM1.33333 1.5H14.6667V14.5H1.33333V1.5Z" fill="currentColor" />
</svg>
